export const CHANGE_INFO_USER_REQUEST = "CHANGE-USER-REQUEST";
export const CHANGE_INFO_USER_SUCCESS = "CHANGE-USER-SUCCESS";
export const CHANGE_INFO_USER_FAIL = "CHANGE-USER-FAIL";
